export default () => ({
  init() {
    // Home page initialization
  }
})
